import { useEffect, useState } from "react";

import { TextField, Select, Checkbox } from "@king-ict/eupisi-ui/components";
import { CodeBook } from "@king-ict/eupisi-ui/models";
import { codeBookToSelectData, nameof } from "@king-ict/eupisi-ui/utils";
import { Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router";

import { getGroupById, saveGroup } from "../../api/Faq/FaqApi";
import { useAppDispatch } from "../../app/store";
import {
  ContentArea,
  FormCard,
  ToolbarEdit,
  ToolbarTop,
} from "../../components";
import { ValidationFailure } from "../../models";
import { FaqApplicationDisplay, Group } from "../../models/Faq";
import { faqGroupDetailUrl } from "../../routes/routes";
import { resetIsEdited, setIsEdited } from "../../slices/applicationSlice";

export function FaqGroupEdit() {
  const { id } = useParams<{ id: string }>();
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const createDefaultGroup = (): Group => {
    return {
      id: 0,
      name: "",
      faqApplicationDisplayId: 1,
      status: true,
    };
  };
  const [group, setGroup] = useState<Group>(createDefaultGroup);
  const [faqApplicationDisplays] = useState<CodeBook[]>(() => {
    const arrayObjects = [] as CodeBook[];
    for (const [propertyKey, propertyValue] of Object.entries(
      FaqApplicationDisplay
    )) {
      var num = Number(propertyKey);
      if (Number.isNaN(Number(propertyKey))) {
        continue;
      }
      var tranKey = "common.faq.faqApplicationDisplay." + propertyValue;
      var trans = t(tranKey);
      arrayObjects.push({ id: num, name: trans });
    }
    return arrayObjects;
  });
  const [errors, setErrors] = useState<ValidationFailure[]>();

  useEffect(() => {
    (async () => {
      if (!isNaN(+id) && +id > 0) {
        var result = await getGroupById(+id);
        if (result) {
          setGroup(result);
        }
      }
    })();
    dispatch(resetIsEdited());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const handleNameChange = (e: any) => {
    const name = e.target.value;
    const newGroup: Group = {
      ...group,
      name: name,
    };
    setGroup(newGroup);
    dispatch(setIsEdited());
  };
  const handleApplicationDisplayChange = (e: any) => {
    const faqApplicationDisplayId = Number.parseInt(e.target.value);
    const newGroup: Group = {
      ...group,
      faqApplicationDisplayId: faqApplicationDisplayId,
    };
    setGroup(newGroup);
    dispatch(setIsEdited());
  };
  const handleStatusChange = () => {
    const status = group.status;
    const newGroup: Group = {
      ...group,
      status: !status,
    };
    setGroup(newGroup);
    dispatch(setIsEdited());
  };

  return (
    <ContentArea>
      <ToolbarTop
        showBack="show"
        pageTitle={t("common.faq.groupPageName")}
        errors={errors}
      ></ToolbarTop>
      <FormCard>
        <Row>
          <Col md={6}>
            <TextField
              label={t("common.faq.name")}
              name={"group.name"}
              value={group.name}
              onChange={handleNameChange}
              errorText={
                errors?.find((e) => e.propertyName === "Name")?.message
              }
            />
          </Col>
        </Row>
        <Row>
          <Col md={6}>
            <Select
              label={t("common.faq.applicationDisplay")}
              name={nameof<typeof group>("faqApplicationDisplayId")}
              value={group.faqApplicationDisplayId}
              onChange={handleApplicationDisplayChange}
              selectData={codeBookToSelectData(faqApplicationDisplays)}
            />
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <Checkbox
              label={t("common.faq.active")}
              name={nameof<typeof group>("status")}
              checked={group.status}
              onChange={handleStatusChange}
            />
          </Col>
        </Row>
      </FormCard>
      <ToolbarEdit
        showSave={"show"}
        showCancel="show"
        handleSave={async () => saveGroup(group)}
        redirectUrlSaveOK={faqGroupDetailUrl}
        setSaveErrors={setErrors}
      ></ToolbarEdit>
    </ContentArea>
  );
}
